module.exports = {"532928101":"博南镇","532928102":"杉阳镇","532928103":"龙街镇","532928201":"龙门乡","532928202":"北斗彝族乡","532928203":"厂街彝族乡","532928204":"水泄彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532928.json
// module id = 2464
// module chunks = 0